import { useRouter } from 'next/navigation';

interface RedirectOptions {
    newTab?: boolean;
}

export const useRedirect = () => {
    const router = useRouter();

    const redirect = (path: string, options: RedirectOptions = { newTab: false }) => {
        if (path.includes('http') || path.includes('tel:') || path.includes('mailto:') || options.newTab) {
            const a = document.createElement('a');
            a.setAttribute('href', path);
            a.setAttribute('rel', 'noopener noreferrer');
            a.setAttribute('target', '_blank');
            a.click();
            return;
        }

        router.push(path);
    };

    return redirect;
};
